import { nextTick } from 'vue';
import { createWorkspaceTransitions } from './workspace-transitions.js';

export const workspaceMotion = createWorkspaceTransitions({ render: nextTick });
export function switchWorkspace(update, direction = 1, changed = true) {
  if (!changed && !workspaceMotion.pending) return;
  return workspaceMotion.run(update, { direction, commitOnCancel: false });
}
